
import React from 'react'
import { Switch, Route,Router,BrowserRouter } from 'react-router-dom'
import About from './about.js'
import Download from './download.js'
import Contact from './contact.js'

const SiteRoutes = () => (
  <main>
 <BrowserRouter>
        <Switch>
            <Route exact path="/usaquake-website/" component={About} />
      </Switch>
  </BrowserRouter> 
   </main>
)

export default SiteRoutes;